import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'virtues-bootstrap';
import { CVI_TYPES } from 'constants/medical';

import { ReactComponent as IconFileDownload } from 'svg/file-download-solid.svg';
import s from './styles.module.scss';

const CardiovascularInvestigationsRow = ({
  total,
  id,
  lastUpdated,
  t,
  index,
  downloadDocumentReferencePdf,
  patientId,
}) => (
  <tr key={`${id}${lastUpdated}`}>
    <td>{t(`cardiovascularInvestigations.${CVI_TYPES[index]}`)}</td>
    <td>
      {total ? (
        <div className={s.response}>
          <div>{lastUpdated}</div>
          <div>
            <Button
              icon={<IconFileDownload />}
              variant="link-secondary"
              onClick={() =>
                downloadDocumentReferencePdf({
                  url: `DocumentReference/${id}`,
                  fileName: `RPM-CIED-${patientId}-${CVI_TYPES[index]}-${lastUpdated}`,
                })
              }
            >
              {t('download')}
            </Button>
          </div>
        </div>
      ) : (
        <div className={s.response}>
          <div>{t('NA')}</div>
        </div>
      )}
    </td>
  </tr>
);

CardiovascularInvestigationsRow.propTypes = {
  total: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  lastUpdated: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  downloadDocumentReferencePdf: PropTypes.func.isRequired,
  patientId: PropTypes.string.isRequired,
};

export default CardiovascularInvestigationsRow;
